import React from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';

class HorizontalLazyLoad extends React.PureComponent {
  constructor() {
    super();
    this.state = {};
    this.ref = React.createRef();
    this.callbackCalled = false;
  }
  componentDidMount() {
    this.addElemEventListener();
  }

  addElemEventListener = () => {
    this.scrollFunc = this.monitorScroll();
    if (this.ref && this.ref.current) {
      const elem = this.ref.current;
      this.setElemProperties();
      elem.addEventListener('scroll', this.scrollFunc);
    }
  };

  setElemProperties = () => {
    const elem = this.ref.current;
    this.elemScrollWidth = elem.scrollWidth;
    this.elemWidth = elem.clientWidth;
  };

  componentWillUnmount() {
    if (this.ref && this.ref.current) {
      this.ref.current.removeEventListener('scroll', this.scrollFunc);
    }
  }

  monitorScroll = (throttleTime = 0) =>
    throttle(this.handleScrollEvent, throttleTime);

  handleScrollEvent = () => {
    // eslint-disable-next-line no-restricted-globals
    const marginFromRight = isNaN(this.props.marginFromRight)
      ? 0
      : parseInt(this.props.marginFromRight, 10);
    if (
      typeof this.props.callback === 'function' &&
      !this.callbackCalled &&
      this.ref.current.scrollLeft + this.elemWidth + marginFromRight >=
        this.elemWidth
    ) {
      this.ref.current.removeEventListener('scroll', this.scrollFunc);
      this.props.callback(this.resetCallback);
      this.callbackCalled = true;
    }
  };

  resetCallback = () => {
    this.callbackCalled = false;
    this.addElemEventListener();
  };

  render() {
    return (
      <div className={this.props.classes || ''} ref={this.ref}>
        {this.props.children}
      </div>
    );
  }
}

HorizontalLazyLoad.propTypes = {
  callback: PropTypes.func,
  children: PropTypes.node.isRequired,
  classes: PropTypes.string,
  marginFromRight: PropTypes.string,
};

HorizontalLazyLoad.defaultProps = {
  callback: () => {},
  classes: '',
  marginFromRight: '0',
};

export default HorizontalLazyLoad;
